import { ErrorResponse } from '../core/models/error-response.model';

export const base = {
  icon: undefined,
  titleText: "",
  text: "",
  showCancelButton: true,
  closeButtonHtml: ``,
  imageAlt: "Logo de Confirmação",
  imageUrl: "/assets/images/modals/ilustracion-obrigado@2x.png",
  customClass: {
    container: "c-sweetCustom_container",
    popup: "c-sweetCustom_popup",
    header: "c-sweetCustom_header",
    title: "c-sweetCustom_title",
    closeButton: "c-sweetCustom_closeBtn",
    icon: "c-sweetCustom_icon",
    image: "c-sweetCustom_image",
    content: "c-sweetCustom_content",
    input: "c-sweetCustom_input",
    actions: "c-sweetCustom_actions",
    confirmButton: "c-sweetCustom_btnConfirm",
    cancelButton: "c-sweetCustom_btnCancel",
    footer: "c-sweetCustom_footer",
  },
};

export const success = {
  icon: undefined,
  showConfirmButton: false,
  showCancelButton: false,
  showCloseButton: true,
  closeButtonHtml: `<svg class="c-icon c-icon--xs"><use xlink:href="#ic-sweet-close" /></svg>`,
  customClass: { ...base.customClass },
};

export const error = {
  icon: undefined,
  showCancelButton: false,
  showCloseButton: true,
  confirmButtonText: "Entendi",
  closeButtonHtml: `<svg class="c-icon c-icon--xs"><use xlink:href="#ic-sweet-close" /></svg>`,
  customClass: { ...base.customClass },
};

export const question = {
  icon: undefined,
  reverseButtons: true,
  showCancelButton: true,
  showCloseButton: true,
  confirmButtonText: "Entendi",
  closeButtonHtml: `<svg class="c-icon c-icon--xs"><use xlink:href="#ic-sweet-close" /></svg>`,
  customClass: {
    ...base.customClass,
    content: "c-sweetCustom_content c-sweetCustom_content--question",
    actions: "c-sweetCustom_actions--question",
  },
};

export const questionHtml = (title = "", text = "", icon = "") => {
  return `<div class="swal2-content c-sweetCustom_content">
            ${
              icon
                ? '<svg class="c-icon c-sweetCustom_content_icon"><use xlink:href="#' +
                  icon +
                  '" /></svg>'
                : ""
            }
            ${
              title
                ? '<h3 class="c-sweetCustom_title--error">' + title + "</h3>"
                : ""
            }
            ${text ? '<p class="c-sweetCustom_text">' + text + "</p>" : ""}
          </div>`;
};

export const successHtml = (
  title = "Ação realizada com sucesso",
  text = ""
) => {
  return `<div class="swal2-content c-sweetCustom_content">
            <svg class="c-icon c-sweetCustom_content_icon"><use xlink:href="#ic-sweet-success" /></svg>
            ${
              title
                ? '<h3 class="c-sweetCustom_title--success">' + title + "</h3>"
                : ""
            }
            ${text ? '<p class="c-sweetCustom_text">' + text + "</p>" : ""}
          </div>`;
};

function escapeHtml(str: string): string {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export const errorHtml = (errorOrTitle: string | ErrorResponse | any, additionalText?: string) => {
  let title = "";
  let text = "";

  // Handle different input patterns
  if (typeof errorOrTitle === 'object' && errorOrTitle !== null) {
    if (errorOrTitle.error?.message) {
      // Handle HTTP error response
      title = errorOrTitle.error.message;
      text = errorOrTitle.error.details || additionalText || '';
    } else if (errorOrTitle.message) {
      // Handle direct error response
      title = errorOrTitle.message;
      text = errorOrTitle.details || additionalText || '';
    } else if (errorOrTitle.error?.errors) {
      // Handle legacy validation errors
      title = "Erro de validação";
      text = Array.isArray(errorOrTitle.error.errors)
        ? errorOrTitle.error.errors.join("\n")
        : Object.values(errorOrTitle.error.errors).join("\n");
    } else {
      // Handle other object formats
      title = errorOrTitle.error || "Erro";
      text = additionalText || '';
    }
  } else {
    // Handle string input (old pattern with title and text)
    title = errorOrTitle || "Erro";
    text = additionalText || '';
  }

  return `<div class="swal2-content c-sweetCustom_content">
            <svg class="c-icon c-sweetCustom_content_icon"><use xlink:href="#ic-sweet-cancel" /></svg>
            ${title ? '<h3 class="c-sweetCustom_title--error">' + escapeHtml(title) + "</h3>" : ""}
            ${text ? '<p class="c-sweetCustom_text c-sweetCustom_errorMessage">' + escapeHtml(text) + "</p>" : ""}
          </div>`;
};
